'use client';

import { theme } from 'components/index';
import Image from 'next/image';
import styles from './prompt-client.module.css';

const Prompt = ({ title }: { title?: string }) => {
  return (
    <main
      style={{
        backgroundColor: theme.colors.background,
        height: '100vh',
        color: theme.colors.primary,
      }}
    >
      <section className={`${styles.promptContainer} u-grid`}>
        <Image
          width="200"
          height="200"
          className="logo-image"
          src="/UH_logo-640.png"
          alt="ultrahuman logo"
        />
        <div className={styles.promptContent}>
          <h1>{title}</h1>
        </div>
      </section>
    </main>
  );
};

export default Prompt;
